import { Component, OnInit, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { global } from '../../shared/global';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-changepincode',
  templateUrl: './changepincode.component.html',
  styleUrls: ['./changepincode.component.css']
})
export class ChangepincodeComponent implements OnInit {

  @ViewChild('addPincodeForm', { static: true }) addPincodeForm: NgForm;

  termConditionLink: any;
  mobile: any;
  cookieValue: any;
  pincodeValue: any;
  pincodeLists: any;

  constructor(private cookieService: CookieService, private router: Router) { }

  ngOnInit() {
    this.termConditionLink = global.termConditionLink;

    this.cookieValue = this.cookieService.get("login");
    if (this.cookieValue) {
      this.cookieValue = JSON.parse(this.cookieService.get("login"));
      this.mobile = this.cookieValue.mobile;
    } else {
      this.router.navigate(["/login"]);
    }

    this.pincodeValue = this.cookieService.get("pincodes");
    if(this.pincodeValue) {
      this.pincodeLists = JSON.parse(this.cookieService.get("pincodes"));
    }
  }

  setVendorConfig() {
    var objConfig = {
      "isStaff": 0
    }

    this.cookieService.set("config", JSON.stringify(objConfig));
  }

  logout() {
    this.cookieService.delete("login");
    this.cookieService.delete("locations");
    this.cookieService.delete("shop");
    this.cookieService.delete("staff");
    this.cookieService.delete("config");
    this.cookieService.delete("pincodes");
    this.router.navigate(["/login"]);
  }

  onSubmit(pincode) {
    if (this.addPincodeForm.valid) {
      
      for (var pin in this.pincodeLists) {
        if (this.pincodeLists[pin].pincode == pincode) {
          this.addPincodeForm.resetForm();
          $('#addPincodeModal').modal('hide');
          return;    
        }
      }

      var objPincode = {
        "pincode": pincode,
        "selected": 0
      };
      this.pincodeLists.push(objPincode);

      this.cookieService.set("pincodes", JSON.stringify(this.pincodeLists));
      this.addPincodeForm.resetForm();
      $('#addPincodeModal').modal('hide');
    } else {
      console.log("Invalid");
    }
  }

  setPincode(pincode) {
    this.cookieService.delete("pincodes");

    var pinLists = this.pincodeLists;
    this.pincodeLists = [];

    for (var val in pinLists) {
      var objPin = {
        "pincode": pinLists[val].pincode,
        "selected":(pinLists[val].pincode == pincode ? 1 : 0)
      }

      this.pincodeLists.push(objPin);
    }

    this.cookieService.set("pincodes", JSON.stringify(this.pincodeLists));
    
    this.pincodeLists = JSON.parse(this.cookieService.get("pincodes"));

    this.router.navigate(["/customer"]);
  }

  cancel() {
    this.addPincodeForm.resetForm();
  }

  deletePincode(pincode) {
    for (var pin in this.pincodeLists) {
      if (this.pincodeLists[pin].pincode === pincode) {
          this.pincodeLists.splice(pin, 1);
          break;
      }
  }

  this.cookieService.set("pincodes", JSON.stringify(this.pincodeLists));
  }
}
